import { Button, cn, AnalyticsEvent } from '@cibli/shared';
import { ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { useTrackEvent } from '@/lib/analytics/use-track-event';

interface Props {
  className?: string;
  disableNextButton?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
  stepName?: string;
  /** Overrides the default "Next" label (e.g. "Passer l'étape" on optional steps). */
  nextLabel?: string;
}

export default function FormButtons({
  className,
  disableNextButton,
  showBackButton = false,
  onBack,
  stepName,
  nextLabel,
}: Props) {
  const { t } = useTranslation();
  const trackEvent = useTrackEvent();

  const handleSubmitClick = () => {
    if (stepName) {
      trackEvent({ event: AnalyticsEvent.NEXT_REGISTER_STEP, props: { step: stepName } });
    }
  };

  return (
    <div className={cn('flex flex-row w-full justify-between', className)}>
      <Button
        size="lg"
        variant="secondary"
        type="button"
        className={showBackButton ? 'visible' : 'invisible'}
        onClick={showBackButton ? onBack : undefined}
      >
        <ArrowLeftIcon className="size-4" strokeWidth={3} />
        {t('common.back')}
      </Button>
      <Button disabled={disableNextButton} size="lg" type="submit" onClick={handleSubmitClick}>
        {nextLabel ?? t('common.next')}
        <ArrowRightIcon className="size-4" strokeWidth={3} />
      </Button>
    </div>
  );
}
